/**
 * CJSUSPENSION model-page heading cleanup.
 *
 * Display-only polish for shared model pages. Source metaobject titles, SEO,
 * page H1s and master-library tokens remain untouched.
 * Recovery resync: 2026-09-01.
 */
(function () {
  'use strict';

  var BRANDS = [
    'Cane Creek',
    'X-Fusion',
    'RockShox',
    'Marzocchi',
    'Specialized',
    'Vorsprung',
    'Manitou',
    'Öhlins',
    'Ohlins',
    'Formula',
    'Fox',
    'DVO',
    'EXT',
    'BOS',
    'FAST',
    'KS'
  ];

  function cleanSpace(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getContext(root) {
    var heroHeading = root.querySelector('.cjs-model-hero h1');
    var eyebrow = root.querySelector('.cjs-model-eyebrow');
    var h1 = cleanSpace(heroHeading ? heroHeading.textContent : '');
    var eyebrowText = cleanSpace(eyebrow ? eyebrow.textContent : '');

    var isFork = /Fork Servicing/i.test(eyebrowText);
    var isRearAir = /Rear Air Shock Servicing/i.test(eyebrowText);
    var isRearShock = /Rear Shock Servicing/i.test(eyebrowText);
    var isDropper = /Dropper Servicing/i.test(eyebrowText);
    var modelName = h1;

    if (isFork) {
      modelName = modelName.replace(/\s+Fork Service New Zealand$/i, '');
    } else if (isDropper) {
      modelName = modelName
        .replace(/\s+Dropper Service New Zealand$/i, '')
        .replace(/\s+Dropper Post Service New Zealand$/i, '');
    } else {
      modelName = modelName.replace(/\s+Service New Zealand$/i, '');
    }

    modelName = modelName.trim();

    var brandless = modelName;
    for (var i = 0; i < BRANDS.length; i += 1) {
      var brandPattern = new RegExp('^' + escapeRegExp(BRANDS[i]) + '\\s+', 'i');
      if (brandPattern.test(brandless)) {
        brandless = brandless.replace(brandPattern, '').trim();
        break;
      }
    }

    var primaryModel = brandless
      .split(/\s+(?:\/|&|and)\s+|\s*\/\s*/i)[0]
      .trim();

    var aliases = [modelName, brandless, primaryModel]
      .map(cleanSpace)
      .filter(Boolean)
      .filter(function (value, index, list) {
        return list.map(function (item) { return item.toLowerCase(); }).indexOf(value.toLowerCase()) === index;
      })
      .sort(function (a, b) { return b.length - a.length; });

    return {
      aliases: aliases,
      isFork: isFork,
      isRearAir: isRearAir,
      isRearShock: isRearShock,
      isDropper: isDropper,
      modelName: modelName
    };
  }

  function stripModelReference(value, aliases) {
    var output = cleanSpace(value);

    aliases.forEach(function (alias) {
      if (!alias) return;

      var escaped = escapeRegExp(alias);

      output = output.replace(
        new RegExp('^((?:25|50|100)\\s*hr)\\s+' + escaped + '(?=\\s|$)', 'i'),
        '$1'
      );

      output = output.replace(
        new RegExp('^' + escaped + '(?=\\s|$)', 'i'),
        ''
      );

      output = cleanSpace(output.replace(/^[-–—:|]+\s*/, ''));
    });

    return output;
  }

  function canonicalServiceTitle(value, context) {
    var output = stripModelReference(value, context.aliases);
    var interval = cleanSpace(value).match(/\b(25|50|100)\s*hr\b/i);

    if (!interval) return output;

    var hours = interval[1];

    if (hours === '100') return '100hr Full Service';

    if (hours === '25') {
      if (context.isFork) return '25hr Lower Leg Service';
      if (context.isRearAir) return '25hr Air Sleeve Service';
      return '25hr Service';
    }

    if (hours === '50') {
      if (/clean\s*&?\s*regas|clean and regas/i.test(value)) return '50hr Clean & Regas Service';
      if (context.isFork) return '50hr Lower Leg Service';
      if (context.isRearAir) return '50hr Air Sleeve Service';
      return '50hr Service';
    }

    return output;
  }

  function canonicalRepairTitle(value, context) {
    var output = stripModelReference(value, context.aliases);
    var original = cleanSpace(value);

    if (context.isRearShock && /^Spring Setup$/i.test(output)) {
      return 'Coil Spring Setup';
    }

    var exactPhrases = [
      'Removal & Installation From MTB',
      'Custom Damper Tuning',
      'Fork Damper Servicing',
      'Damper Servicing',
      'Fork Scratch Repair',
      'Stanchion Scratch Repair',
      'Steerer Tube Replacement',
      'CSU De-Creak Service',
      'Fork Air Volume Spacer Setup',
      'Rear Shock Air Volume Spacer Setup',
      'Air Volume Spacer Setup',
      'Coil Spring Setup'
    ];

    for (var i = 0; i < exactPhrases.length; i += 1) {
      if (original.toLowerCase().indexOf(exactPhrases[i].toLowerCase()) !== -1) {
        return exactPhrases[i];
      }
    }

    return output;
  }

  function canonicalUpgradeTitle(value, context) {
    return stripModelReference(value, context.aliases);
  }

  function cleanSectionHeading(heading, context) {
    var value = cleanSpace(heading.textContent);

    if (/Performance Upgrades$/i.test(value)) {
      if (heading.textContent !== 'Performance Upgrades') heading.textContent = 'Performance Upgrades';
      return;
    }

    if (/Repairs?,\s*Setup\s*&\s*Tuning$/i.test(value)) {
      if (heading.textContent !== 'Repairs, Setup & Tuning') heading.textContent = 'Repairs, Setup & Tuning';
      return;
    }

    if (/Setup\s*&\s*Custom Tuning$/i.test(value)) {
      if (heading.textContent !== 'Setup & Custom Tuning') heading.textContent = 'Setup & Custom Tuning';
      return;
    }

    if (/Repairs?\s*&\s*Custom Tuning$/i.test(value)) {
      var repairHeading = value.match(/Repairs?\s*&\s*Custom Tuning$/i)[0];
      if (heading.textContent !== repairHeading) heading.textContent = repairHeading;
      return;
    }

    if (/Servicing$/i.test(value)) {
      if (heading.textContent !== 'Servicing') heading.textContent = 'Servicing';
      return;
    }

    var stripped = stripModelReference(value, context.aliases);
    if (stripped && stripped !== value) heading.textContent = stripped;
  }

  function cleanHeadings(root) {
    if (!root) return;

    var context = getContext(root);
    if (!context.aliases.length) return;

    var supportHeading = root.querySelector('.cjs-model-support h2');
    if (supportHeading && /Workshop Support$/i.test(cleanSpace(supportHeading.textContent))) {
      if (supportHeading.textContent !== 'Workshop Support') supportHeading.textContent = 'Workshop Support';
    }

    root.querySelectorAll('.cjs-model-section-head h2').forEach(function (heading) {
      var panel = heading.closest('.cjs-model-panel');
      if (!panel) return;

      if (panel.querySelector('.cjs-model-card-grid') || panel.querySelector('.cjs-model-upgrade-grid')) {
        cleanSectionHeading(heading, context);
      }
    });

    root.querySelectorAll('.cjs-model-section').forEach(function (section) {
      var grid = section.querySelector('.cjs-model-card-grid');
      if (!grid) return;

      var heading = section.querySelector('.cjs-model-section-head h2');
      var headingText = cleanSpace(heading ? heading.textContent : '');
      var isServiceSection = /^Servicing$/i.test(headingText);

      grid.querySelectorAll('.cjs-model-card h3').forEach(function (cardHeading) {
        var cleaned = isServiceSection
          ? canonicalServiceTitle(cardHeading.textContent, context)
          : canonicalRepairTitle(cardHeading.textContent, context);

        if (cleaned && cleanSpace(cardHeading.textContent) !== cleaned) {
          cardHeading.textContent = cleaned;
        }
      });
    });

    root.querySelectorAll('.cjs-model-upgrade-card h3').forEach(function (heading) {
      var cleaned = canonicalUpgradeTitle(heading.textContent, context);
      if (cleaned && cleanSpace(heading.textContent) !== cleaned) {
        heading.textContent = cleaned;
      }
    });
  }

  function removeEmptyUpgradeFitNotes(root) {
    if (!root) return;

    root.querySelectorAll('.cjs-model-upgrade-grid').forEach(function (grid) {
      var panel = grid.closest('.cjs-model-panel');
      if (!panel) return;

      panel.querySelectorAll('.cjs-model-info-box').forEach(function (box) {
        var heading = box.querySelector('strong');
        if (!heading || !/^Not sure what fits\?$/i.test(cleanSpace(heading.textContent))) return;

        var noteText = Array.prototype.map.call(box.querySelectorAll('p'), function (paragraph) {
          return cleanSpace(paragraph.textContent);
        }).join('');

        if (!noteText) box.remove();
      });
    });
  }

  function ensurePolishStyles() {
    if (document.getElementById('cjs-model-recovery-polish')) return;

    var style = document.createElement('style');
    style.id = 'cjs-model-recovery-polish';
    style.textContent = '.cjs-model-service[data-cjs-single-service="true"] .cjs-model-section[data-cjs-service-section] .cjs-model-card-grid{grid-template-columns:minmax(0,520px)!important;justify-content:center!important;}';
    document.head.appendChild(style);
  }

  function polishModelLayout(root) {
    if (!root) return;

    var serviceSection = null;

    root.querySelectorAll('.cjs-model-section').forEach(function (section) {
      var heading = section.querySelector('.cjs-model-section-head h2');
      var grid = section.querySelector('.cjs-model-card-grid');
      if (!heading || !grid) return;

      if (/^Servicing$/i.test(cleanSpace(heading.textContent))) {
        serviceSection = section;
        section.setAttribute('data-cjs-service-section', '');
      }
    });

    if (serviceSection) {
      var cards = Array.prototype.slice.call(serviceSection.querySelectorAll('.cjs-model-card'));
      root.setAttribute('data-cjs-single-service', cards.length === 1 ? 'true' : 'false');
    }

    ensurePolishStyles();
  }

  function removeUnapprovedBosProgressivityLinks(root) {
    if (!root) return;

    root.querySelectorAll(
      '[data-cjs-bos-progressivity-link], a[href="/pages/bos-air-volume-setup"], a[href$="/pages/bos-air-volume-setup"]'
    ).forEach(function (link) {
      link.remove();
    });

    root.querySelectorAll('a.cjs-model-button').forEach(function (link) {
      var label = cleanSpace(link.textContent).toLowerCase();

      if (label === 'view bos air volume setup' || label === 'view bos kirk progressivity kit') {
        link.remove();
      }
    });
  }

  var running = false;
  var queued = false;

  function run() {
    if (running) return;

    var root = document.querySelector('.cjs-model-service');
    if (!root) return;

    running = true;
    cleanHeadings(root);
    removeEmptyUpgradeFitNotes(root);
    polishModelLayout(root);
    removeUnapprovedBosProgressivityLinks(root);
    running = false;
  }

  function queueRun() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.setTimeout(run, 100);
  window.setTimeout(run, 500);
  window.setTimeout(run, 1200);
  window.setTimeout(run, 2500);
  window.setTimeout(run, 5000);

  document.addEventListener('shopify:section:load', run);

  var observer = new MutationObserver(function (mutations) {
    if (running) return;

    var relevant = mutations.some(function (mutation) {
      return mutation.type === 'childList' || mutation.type === 'characterData';
    });

    if (relevant) queueRun();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();

/**
 * CJSUSPENSION MTB services brand navigation.
 * Keeps the "Brands We Service" pill row aligned with the canonical
 * Brands We Service hub and makes every pill a real internal link.
 */
(function () {
  'use strict';

  var path = String(window.location.pathname || '').replace(/\/$/, '').toLowerCase();
  if (path !== '/pages/mtb-suspension-services') return;

  var SERVICE_BRANDS = [
    { label: 'Fox', url: '/pages/fox-suspension-service' },
    { label: 'RockShox', url: '/pages/rockshox-suspension-service' },
    { label: 'DVO', url: '/pages/dvo-suspension-service' },
    { label: 'Marzocchi', url: '/pages/marzocchi-suspension-service' },
    { label: 'Öhlins', url: '/pages/ohlins-suspension-service' },
    { label: 'Vorsprung', url: '/pages/vorsprung-suspension-service' },
    { label: 'Cane Creek', url: '/pages/cane-creek-suspension-service' },
    { label: 'FAST Suspension', url: '/pages/fast-suspension-service' },
    { label: 'EXT', url: '/pages/ext-suspension-service' },
    { label: 'BOS', url: '/pages/bos-suspension-service' },
    { label: 'Manitou', url: '/pages/manitou-suspension-service' },
    { label: 'X-Fusion', url: '/pages/x-fusion-suspension-service' },
    { label: 'KS', url: '/pages/ks-dropper-service' },
    { label: 'BikeYoke', url: '/pages/bikeyoke-dropper-service' },
    { label: 'Specialized', url: '/pages/specialized-dropper-service' },
    { label: 'Race Face', url: '/pages/race-face-dropper-service' },
    { label: 'All Brands', url: '/pages/brands-we-service' }
  ];

  var CURRENT_LABELS = [
    'Fox',
    'RockShox',
    'Marzocchi',
    'Öhlins',
    'DVO',
    'EXT',
    'Cane Creek',
    'X-Fusion',
    'KS',
    'All Major MTB Suspension Brands'
  ];

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isKnownCurrentLabel(value) {
    var text = normalise(value);
    return CURRENT_LABELS.some(function (label) {
      return normalise(label) === text;
    });
  }

  function findBrandsHeading() {
    var headings = document.querySelectorAll('h1, h2, h3, h4');
    for (var i = 0; i < headings.length; i += 1) {
      if (normalise(headings[i].textContent) === 'brands we service') return headings[i];
    }
    return null;
  }

  function matchingLeafCount(container) {
    var count = 0;
    var nodes = container.querySelectorAll('a, button, span, li, div');

    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (!isKnownCurrentLabel(node.textContent)) continue;

      var childMatches = Array.prototype.some.call(node.children, function (child) {
        return isKnownCurrentLabel(child.textContent);
      });

      if (!childMatches) count += 1;
    }

    return count;
  }

  function findPillContainer(section) {
    var candidates = section.querySelectorAll('div, ul, ol');
    var best = null;
    var bestLength = Infinity;

    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];
      if (matchingLeafCount(candidate) < 5) continue;

      var length = String(candidate.textContent || '').replace(/\s+/g, ' ').trim().length;
      if (length < bestLength) {
        best = candidate;
        bestLength = length;
      }
    }

    return best;
  }

  function findPrototype(container) {
    var children = Array.prototype.slice.call(container.children);
    var direct = children.find(function (child) {
      return normalise(child.textContent) === 'fox';
    });

    if (direct) return direct;

    var leaf = Array.prototype.slice.call(container.querySelectorAll('a, button, span, li, div')).find(function (node) {
      return normalise(node.textContent) === 'fox';
    });

    if (!leaf) return null;

    var node = leaf;
    while (node.parentElement && node.parentElement !== container) node = node.parentElement;
    return node.parentElement === container ? node : leaf;
  }

  function copyPresentationAttributes(source, target) {
    if (!source || !target) return;

    Array.prototype.forEach.call(source.attributes || [], function (attribute) {
      if (attribute.name === 'href' || attribute.name === 'role' || attribute.name === 'aria-disabled') return;
      target.setAttribute(attribute.name, attribute.value);
    });
  }

  function buildPill(prototype, item) {
    if (!prototype) {
      var fallback = document.createElement('a');
      fallback.href = item.url;
      fallback.textContent = item.label;
      fallback.setAttribute('data-cjs-service-brand-link', '');
      return fallback;
    }

    if (prototype.tagName === 'A') {
      var directLink = document.createElement('a');
      copyPresentationAttributes(prototype, directLink);
      directLink.href = item.url;
      directLink.textContent = item.label;
      directLink.setAttribute('data-cjs-service-brand-link', '');
      return directLink;
    }

    var clone = prototype.cloneNode(true);
    var nestedLink = clone.querySelector('a');

    if (nestedLink) {
      nestedLink.href = item.url;
      nestedLink.textContent = item.label;
      nestedLink.removeAttribute('role');
      nestedLink.removeAttribute('aria-disabled');
      nestedLink.setAttribute('data-cjs-service-brand-link', '');
      return clone;
    }

    var leaf = Array.prototype.slice.call(clone.querySelectorAll('span, button, div')).find(function (node) {
      return isKnownCurrentLabel(node.textContent) && node.children.length === 0;
    });

    if (leaf) {
      var link = document.createElement('a');
      copyPresentationAttributes(leaf, link);
      link.href = item.url;
      link.textContent = item.label;
      link.setAttribute('data-cjs-service-brand-link', '');
      leaf.replaceWith(link);
      return clone;
    }

    var replacement = document.createElement('a');
    copyPresentationAttributes(prototype, replacement);
    replacement.href = item.url;
    replacement.textContent = item.label;
    replacement.setAttribute('data-cjs-service-brand-link', '');
    return replacement;
  }

  function addLinkPolish() {
    if (document.getElementById('cjs-service-brand-link-polish')) return;

    var style = document.createElement('style');
    style.id = 'cjs-service-brand-link-polish';
    style.textContent =
      '[data-cjs-service-brand-link]{color:inherit!important;text-decoration:none!important;}' +
      '[data-cjs-service-brand-link]:hover{text-decoration:none!important;}';
    document.head.appendChild(style);
  }

  function updateBrandPills() {
    var heading = findBrandsHeading();
    if (!heading) return;

    var section = heading.closest('section') || heading.parentElement;
    if (!section) return;

    var container = findPillContainer(section);
    if (!container || container.getAttribute('data-cjs-service-brands-ready') === 'true') return;

    var prototype = findPrototype(container);
    if (!prototype) return;

    container.textContent = '';
    SERVICE_BRANDS.forEach(function (item) {
      container.appendChild(buildPill(prototype, item));
    });

    container.setAttribute('data-cjs-service-brands-ready', 'true');
    addLinkPolish();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBrandPills, { once: true });
  } else {
    updateBrandPills();
  }

  window.setTimeout(updateBrandPills, 250);
  window.setTimeout(updateBrandPills, 900);
  window.setTimeout(updateBrandPills, 1800);
  document.addEventListener('shopify:section:load', updateBrandPills);
})();
